var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 145,
    viewBox: "0 0 213 145",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "wz9y4igl8a",
    d: "M0 0h198.981v102.564H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qgaf05hc3c",
    d: "M0 0h102.538v102.535H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 42.26)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9egh3ofbhb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wz9y4igl8a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m198.981 11.21-97.125 31.684a51.99 51.99 0 0 0-1.223-5.497C92.966 10.142 64.654-5.738 37.397 1.928 10.14 9.597-5.74 37.909 1.93 65.166c7.666 27.256 35.98 43.139 63.236 35.468 15.451-4.346 27.24-15.332 33.163-28.993L198.981 11.21z",
    fill: "#000",
    opacity: 0.018,
    mask: "url(#9egh3ofbhb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.022)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fb9niny2hd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qgaf05hc3c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.538 51.267c0 28.314-22.954 51.268-51.269 51.268C22.954 102.535 0 79.581 0 51.267S22.954 0 51.269 0c28.315 0 51.269 22.954 51.269 51.268",
    fill: "#ED5061",
    mask: "url(#fb9niny2hd)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.603 25.212c-6.249 0-11.65 3.573-14.313 8.78-2.66-5.207-8.062-8.78-14.312-8.78-8.88 0-16.076 7.198-16.076 16.074 0 17.695 23.685 32.267 30.388 36.035 6.704-3.767 30.39-18.34 30.39-36.035 0-8.877-7.197-16.074-16.077-16.074",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED5061",
    d: "m90.15 86.042 122.173-33.35-106.788 4.39z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartImg);
export default __webpack_public_path__ + "static/media/heart_img.2b386e4060d5865e5986f333053448d3.svg";
export { ForwardRef as ReactComponent };